<section class="details-info-container">
  <div class="detail">
    <h2>Detalhes</h2>
  </div>

  <div class="info">
    <!-- <div class="info-item">
      <p>Solicitante</p>
      <span>{{ validation()?.createdBy }}</span>
    </div> -->
    @if (validation()) {
      <div class="inputs">
        <div class="input">
          <p class="label">Solicitante</p>
          <span class="info-text">{{ validation()?.createdByUser?.name }}</span>
        </div>

        <div class="input">
          <p class="label">Data da inserção</p>
          <span class="info-text">{{ validation()?.createdDate | date }}</span>
        </div>
      </div>

      <div class="inputs">
        <div class="input">
          <p class="label">Arquivo</p>
          <a class="link" [href]="validation()?.fileDownloadLink">{{
            validation()?.originalFileName || validation()?.gcsFileName
          }}</a>
        </div>

        <div class="input">
          <p class="label">Nº de áreas de monitoramento</p>
          <span class="info-text">
            {{
              validation()?.featureCount !== null &&
              validation()?.featureCount !== undefined
                ? validation()?.featureCount +
                  (validation()?.featureCount === 1 ? " área" : " áreas")
                : "N/A"
            }}
          </span>
        </div>
        <div class="input">
          <p class="label">Áreas total (ha)</p>
          <span class="info-text"
            >{{ validation()?.totalAreaHa || "N/A" }}
          </span>
        </div>
      </div>
      <div class="inputs">
        <div class="input">
          <p class="label">Inconsistências</p>
          <a class="link" [href]="validation()?.validationDetailDownloadLink">{{
            validation()?.autoValidationDetailFileName
          }}</a>
        </div>

        <div class="input">
          <p class="label">Parecer DataSafra</p>
          <mat-radio-group
            disabled
            [value]="validation()?.autoValidationSuccess"
          >
            <mat-radio-button [value]="true">Consistente</mat-radio-button>
            <mat-radio-button [value]="false">Inconsistente</mat-radio-button>
          </mat-radio-group>
        </div>
        @if (validation()?.generatedGcsFileName !== null) {
          <div class="input">
            <p class="label">Arquivo Gerado</p>
            <a class="link" [href]="validation()?.generatedFileDownloadLink">{{
              validation()?.generatedGcsFileName
            }}</a>
          </div>
        }
      </div>
    }
  </div>
</section>
